function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.6667 80C26.6667 50.6 50.6 26.6667 80 26.6667C109.4 26.6667 133.333 50.6 133.333 80C133.333 109.4 109.4 133.333 80 133.333C50.6 133.333 26.6667 109.4 26.6667 80ZM40 86.6671L66.6667 113.334L120 60.0004L110.6 50.5338L66.6667 94.4671L49.4 77.2671L40 86.6671Z",
  fill: "#B2E4CD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80 13.3333C43.2 13.3333 13.3333 43.2 13.3333 80C13.3333 116.8 43.2 146.667 80 146.667C116.8 146.667 146.667 116.8 146.667 80C146.667 43.2 116.8 13.3333 80 13.3333ZM80 133.333C50.6 133.333 26.6667 109.4 26.6667 80C26.6667 50.6 50.6 26.6667 80 26.6667C109.4 26.6667 133.333 50.6 133.333 80C133.333 109.4 109.4 133.333 80 133.333ZM66.6667 94.4671L110.6 50.5338L120 60.0004L66.6667 113.334L40 86.6671L49.4 77.2671L66.6667 94.4671Z",
  fill: "#00A759"
});

var SvgIcSuccess = function SvgIcSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_success.5445f70f.svg";
export { ForwardRef as ReactComponent };